import { ref, shallowRef } from 'vue'

/**
 * Saving a new card with the family present.
 *
 * The payment form is tied to a SetupIntent from the start, so that is made
 * first; the bank's confirmation then saves the card to their account.
 */
export function useCardSetup() {
  const elements = shallowRef<any>(null)
  const setupSecret = ref<string | null>(null)
  const stripe = shallowRef<any>(null)

  function close() {
    elements.value = null
    setupSecret.value = null
    stripe.value = null
  }

  function onReady(instance: any, instanceElements: any) {
    elements.value = instanceElements
    stripe.value = instance
  }

  async function open() {
    const { data } = await window.axios.post('/student/settings/cards/intent')
    setupSecret.value = data.client_secret
  }

  /** Save the card typed in, and give back its id. */
  async function save(): Promise<string> {
    const result = await stripe.value.confirmSetup({
      confirmParams: { return_url: window.location.href },
      elements: elements.value,
      redirect: 'if_required',
    })

    if (result.error) {
      throw new Error(result.error.message)
    }

    return result.setupIntent.payment_method
  }

  return { close, elements, onReady, open, save, setupSecret }
}
